export default __webpack_public_path__ + "a331f9c23c03a14f0984a473582bb4ac.png";